import { BellOff, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";

type SnoozeBannerProps = {
  end: string | null;
  onLift: () => void;
  isPending: boolean;
  label?: string;
  hideLift?: boolean;
  /** Extra line shown below the main message (e.g. location-level snooze notice) */
  subtitle?: string | null;
};

export const SnoozeBanner = ({
  end,
  onLift,
  isPending,
  label = "This equipment",
  hideLift = false,
  subtitle,
}: SnoozeBannerProps) => {
  const endText = end
    ? `until ${format(new Date(end), "MMM d, yyyy")}`
    : "indefinitely";

  return (
    <div className="flex items-center gap-3 rounded-lg border border-snooze-purple-border bg-snooze-purple-light px-3 py-2.5">
      <BellOff size={16} className="text-snooze-purple shrink-0" />
      <div className="flex-1 text-sm text-slate-700">
        <p>
          <span className="font-medium">{label}</span> is snoozed {endText}.
          Notifications are muted for you, but we are still monitoring the equipment 24/7.
        </p>
        {subtitle && (
          <p className="text-slate-500 mt-0.5">{subtitle}</p>
        )}
      </div>
      {!hideLift && (
        <Button
          variant="outline"
          size="sm"
          onClick={onLift}
          disabled={isPending}
          className="shrink-0"
        >
          {isPending ? (
            <Loader2 className="h-3 w-3 animate-spin" />
          ) : (
            "Lift"
          )}
        </Button>
      )}
    </div>
  );
};
